import { render, staticRenderFns } from "./TicketsInfoSaveAccount.vue?vue&type=template&id=5d47df2c&scoped=true&lang=pug&"
import script from "./TicketsInfoSaveAccount.vue?vue&type=script&lang=js&"
export * from "./TicketsInfoSaveAccount.vue?vue&type=script&lang=js&"
import style0 from "./TicketsInfoSaveAccount.vue?vue&type=style&index=0&id=5d47df2c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47df2c",
  null
  
)

export default component.exports